import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../Contexts/GlobalContext';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';

export default function Init(props) {
    const globalContext = useContext(GlobalContext);
    const getCustomerSettingsHookResponse = useCustomerSettings();

    useEffect (
        () => {
            if(getCustomerSettingsHookResponse.currency) {
                globalContext.dispatchMethod(
                    {
                        type: 'SET_CUSTOMER_SETTINGS',
                        value: { ...getCustomerSettingsHookResponse },
                    }
                )
            }
        },[getCustomerSettingsHookResponse]
    )

    useEffect(
        () => {
            if (!globalContext.globalState.customerSettings.currency) {
                if (localStorage.getItem('ht_adm_cs') != null) {
                    let customerSettings = JSON.parse(localStorage.getItem('ht_adm_cs'));
                    //console.log('setting bla')
                    globalContext.dispatchMethod(
                        {
                            type: 'SET_CUSTOMER_SETTINGS',
                            value: { ...customerSettings },
                        }
                    );

                }
            }
            else {

            }
        }, []
    )

    return (
        <React.Fragment>

        </React.Fragment>
    )
}
//globalContext.globalState.email
//globalContext.globalState.customerAlias